<template>
	<v-card class="flex pa-0 background-2 round-card" v-if="!$store.getters.progress">
        <v-card-title class="pa-3">
            <p class="pl-2 pl-xl-3">Statistiche di Vendita</p>
			<v-spacer></v-spacer>
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="showChart = !showChart" icon :disabled="items.length == 0" :color="showChart ? 'primary' : 'grey darken-1'">
						<v-icon>equalizer</v-icon>
					</v-btn>
				</template>
				<span>{{ showChart ? 'Nascondi Grafico' : 'Visualizza Grafico' }}</span>
			</v-tooltip>
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn v-on="on" @click="$eventBusUtility.exportCSV(headers, items, 'Vendite')" icon :disabled="items.length == 0">
						<v-icon color="grey darken-1">play_for_work</v-icon>
					</v-btn>
				</template>
				<span>Esporta CSV</span>
			</v-tooltip>
        </v-card-title>
		<v-divider></v-divider>
		<v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}">
			<fields-generator
				class="pt-4"
				:fieldsset.sync="fieldsset"
				:model="model"
				ref="fieldsgenerator"
			></fields-generator>

			<top-groups-chart
				v-if="showChart && items.length > 0"
				:items="items"
				:top-n="10"
				series-a-label="Periodo A"
				series-b-label="Periodo B"
				title="Top 10 — Confronto periodi"
				class="mb-4"
			/>

			<v-data-table
				class="background-2"
				:items="items"
				:headers="headers"
				:loading="loading"
				:mobile-breakpoint="0"
				:footer-props="{
					'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }]
				}">
				<template v-slot:item="{ item }">
					<tr class="cursor-pointer">
						<td>
							{{ item['code']}}
						</td>
						<td>
							{{ item['name']}}
						</td>
						<td>
							<strong>
								{{ item['totalrow'] | currency }}
							</strong>
						</td>
						<td>
							{{ item['quantity'] }}
						</td>							    	
						<td>
							{{ item['commission'] | currency}}
						</td>							    	
						<td>
							{{ item['cost'] | currency}}
						</td>							    							    	
						<td>
							{{ item['margin'] | currency}}
						</td>
						<td style="border-left: 1px solid rgba(0,0,0,0.12);">
							<strong>
								{{ item['totalrow_1'] | currency }}
							</strong>
						</td>
						<td>
							{{ item['quantity_1'] }}
						</td>
						<td>
							{{ item['commission_1'] | currency}}
						</td>							    	
						<td>
							{{ item['cost_1'] | currency}}
						</td>							    							    	
						<td>
							{{ item['margin_1'] | currency}}
						</td>
						<td class="text-center">
							<span v-if="item['quantity'] > 0 && item['quantity_1'] == 0" class="success--text">
								<v-icon color="success">trending_up</v-icon>                                            
							</span>                                        
							<span v-else-if="item['trend'] > 0" class="success--text">
								+ {{ item['trend']}} %
								<v-icon color="success">trending_up</v-icon>                                            
							</span>
							<span v-else-if="item['trend'] < 0" class="error--text">
									{{ item['trend']}} %
								<v-icon color="error">trending_down</v-icon>
							</span>
							<span v-else>
								<v-icon color="info">trending_flat</v-icon>                                            
							</span>
						</td>
					</tr>
				</template>
			<template v-slot:footer.page-text="{ pageStart, pageStop }">
				Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
			</template>				
			</v-data-table>

		</v-container>
		<v-slide-y-reverse-transition>

			<v-footer 
				v-show="showFooter" 
				height="auto" 
				class="background-2 elevation-10" 
				fixed  
				app 
				transition="slide-x-transition">
				<v-container class="py-2" fluid >

					<v-row  justify="center">
						<v-col class="pa-0" lg="2" md="2" sm="6" >						
							<v-list two-line class="background-2 w100p pa-0">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">mdi-currency-eur</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Totale A</v-list-item-title>
										<v-list-item-subtitle>{{ totals.totalrow | currency }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-col>
						<v-col class="pa-0" lg="2" md="2" sm="6" >
							<v-list two-line class="background-2 w100p pa-0">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">local_offer</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Quantità A</v-list-item-title>
										<v-list-item-subtitle>{{ totals.quantity }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>       
						</v-col>    
						<v-col class="pa-0" lg="2" md="2" sm="6" >							
							<v-list two-line class="background-2 w100p pa-0">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">mdi-currency-eur</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Provvigione A</v-list-item-title>
										<v-list-item-subtitle>{{ totals.commission | currency }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-col>
						<v-col class="pa-0" lg="2" md="2" sm="6" >
							<v-list two-line class="background-2 w100p pa-0">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">mdi-currency-eur</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Costi A</v-list-item-title>
										<v-list-item-subtitle>{{ totals.cost | currency }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>		
						</v-col>								
						<v-col class="pa-0" lg="2" md="2" sm="6" >
							<v-list two-line class="background-2 w100p pa-0">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">mdi-currency-eur</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Margine A</v-list-item-title>
										<v-list-item-subtitle>{{ totals.margin | currency }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>		
						</v-col>								

					</v-row>
					<v-divider></v-divider>					
					<v-row  justify="center">
						<v-col class="pa-0" lg="2" md="2" sm="6" >						
							<v-list two-line class="background-2 w100p pa-0">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">mdi-currency-eur</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Totale B</v-list-item-title>
										<v-list-item-subtitle>{{ totals.totalrow_1 | currency }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-col>
						<v-col class="pa-0" lg="2" md="2" sm="6" >
							<v-list two-line class="background-2 w100p pa-0">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">local_offer</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Quantità B</v-list-item-title>
										<v-list-item-subtitle>{{ totals.quantity_1 }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>       
						</v-col>    
						<v-col class="pa-0" lg="2" md="2" sm="6" >							
							<v-list two-line class="background-2 w100p pa-0">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">mdi-currency-eur</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Provvigione B</v-list-item-title>
										<v-list-item-subtitle>{{ totals.commission_1 | currency }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-col>
						<v-col class="pa-0" lg="2" md="2" sm="6" >
							<v-list two-line class="background-2 w100p pa-0">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">mdi-currency-eur</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Costi B</v-list-item-title>
										<v-list-item-subtitle>{{ totals.cost_1 | currency }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>		
						</v-col>								
						<v-col class="pa-0" lg="2" md="2" sm="6" >
							<v-list two-line class="background-2 w100p pa-0">
								<v-list-item>
									<v-list-item-action>
										<v-icon color="primary">mdi-currency-eur</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>Margine B</v-list-item-title>
										<v-list-item-subtitle>{{ totals.margin_1 | currency }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>		
						</v-col>								

					</v-row>
				</v-container>
			</v-footer>
		</v-slide-y-reverse-transition>
		<v-fab-transition>
			<v-btn
				color="primary"
				v-model="showFooter"
				dark
				fab
				fixed
				bottom
				right
				@click="showFooter = !showFooter"
				>
				<v-icon v-if="showFooter">expand_more</v-icon>
				<v-icon v-else>expand_less</v-icon>
			</v-btn>
		</v-fab-transition>
	</v-card>
</template>

<script>
	import Vue from 'vue'
	import TopGroupsChart from '@/components/common/TopGroupsChart'

	export default {
		name: 'sold-products',
		components: {
			TopGroupsChart,
		},
		props: {
			url: {
				type: String,
				default: 'soldproducts'
			}
		},

		data() {
			return {
				fieldsset: {},
				debounce: null,
				model: {
					company_id: this.modelId,
				    from_1: moment().startOf('month').subtract(1, 'years').format('YYYY-MM-DD'),
				    to_1: moment().endOf('month').subtract(1, 'years').format('YYYY-MM-DD'),
				    from: moment().startOf('month').format('YYYY-MM-DD'),
				    to: moment().endOf('month').format('YYYY-MM-DD'),                   
				},
				headers: [],
				loaded: false,
				items: [],
				datepicker_menu: {},
				loading: false,
				totals: {
					totalrow: 0,
					quantity: 0,
					commission: 0,
					cost: 0,
					margin: 0,
					totalrow_1: 0,
					quantity_1: 0,
					commission_1: 0,
					cost_1: 0,
					margin_1: 0,
				},
				showFooter: true,
				showChart: false,
				totalItems: 0,
			}
		},

		created() {
			this.axios.get(this.url + '-info').then(response => {
				// get body data
				this.fieldsset = response.data.info.fields
				this.headers = response.data.info.headers

				_.forEach(this.fieldsset.fields, (value, key) => {
					if(value.default) {
						Vue.set(this.model, value.key, value.default)
					}
				})

				this.getData()

				this.$store.commit('endProgress')

			}, response => {
				// error callback
			});
		},

		watch: {
			model: {
				handler() {
					this.getData()
				},
				deep: true,
			}
		},

		methods: {

			getData() {
				this.loading = 'warning'

				if(this.debounce) {
					clearTimeout(this.debounce)
				}

				this.debounce = setTimeout(() => {
					this.axios.post(this.url, this.model).then(response => {
						this.items = response.data.data.result
						this.totalItems = response.data.data.result.length
						this.totals = response.data.data.totals
						this.loading = false
						
					}, response => {
						// error callback
					})
				}, 500)
			},

		},
	}
</script>